import axios from "axios";

export const baseNotificationApi = axios.create({
  baseURL: process.env.VUE_APP_NOTIFICATION_API,
  headers: {
    "Content-type": "application/json",
  },
});
